// Generated from tokens.json by scripts/generate.ts. Do not edit.

export const colorTokens = [
  "background",
  "card",
  "muted",
  "stripe",
  "border",
  "input",
  "foreground",
  "muted-foreground",
  "faint-foreground",
  "primary",
  "primary-hover",
  "primary-foreground",
  "primary-text",
  "primary-soft",
  "secondary",
  "secondary-hover",
  "secondary-foreground",
  "secondary-text",
  "secondary-soft",
  "success",
  "success-soft",
  "warning",
  "warning-solid",
  "warning-soft",
  "destructive",
  "destructive-soft",
  "warning-solid-foreground",
  "ring",
] as const;

export const typeStyles = [
  "display-xl",
  "display-l",
  "heading",
  "title",
  "body-l",
  "body",
  "label",
  "caption",
  "eyebrow",
  "time",
  "score",
] as const;

/** Spacing and size names, as used after a utility prefix (p-space-4, h-tap-min, max-w-dialog). */
export const spacingTokens = [
  "space-1",
  "space-2",
  "space-3",
  "space-4",
  "space-5",
  "space-6",
  "space-7",
  "space-8",
  "tap-min",
  "row-compact",
  "row-comfy",
  "measure",
  "dialog",
  "dialog-narrow",
  "sheet",
  "auth",
] as const;

export const radiusTokens = [
  "sm",
  "md",
  "lg",
  "pill",
] as const;

export const shadowTokens = [
  "raised",
  "float",
] as const;

export const themes = [
  "light",
  "dark",
] as const;

export const shapes = [
  "soft",
  "tailored",
  "crisp",
] as const;

export const voices = [
  "fresh",
  "heritage",
  "editorial",
] as const;
